/**
 * Wave 4 — Landing Pages / Programmatic Batches Cockpit tiles.
 *
 * Small standalone strip mounted below the main KPI grid on `/app/cockpit`.
 * Talks to `/api/v1/lp-v2/stats/cockpit` (added in Wave 4). Silent on error.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Layers } from "lucide-react";
import { api } from "../../lib/api";
import { Card, CardContent } from "../ui/card";

export default function LandingPageCockpitTiles() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    let alive = true;
    api
      .get("/lp-v2/stats/cockpit")
      .then((r) => {
        if (alive) setStats(r.data);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);
  if (!stats) return null;

  const pub = stats?.landing_pages?.published ?? 0;
  const drafts = stats?.landing_pages?.drafts ?? 0;
  const batches = stats?.programmatic?.batches_last_30d ?? 0;

  return (
    <section
      className="grid grid-cols-2 md:grid-cols-4 gap-3"
      data-testid="lpv2-cockpit-tiles"
    >
      <Link to="/app/landing-pages" className="block">
        <Card data-testid="cockpit-tile-landing-pages">
          <CardContent className="p-4">
            <div className="text-xs uppercase tracking-wide text-muted-foreground flex items-center gap-1">
              <FileText className="size-3" /> Landing Pages
            </div>
            <div
              className="mt-2 text-2xl font-semibold tabular-nums"
              data-testid="cockpit-tile-landing-pages-published"
            >
              {pub}
            </div>
            <div className="text-xs text-muted-foreground mt-1">
              <span
                className="font-mono"
                data-testid="cockpit-tile-landing-pages-drafts"
              >
                {drafts}
              </span>{" "}
              drafts
            </div>
          </CardContent>
        </Card>
      </Link>
      <Link to="/app/landing-pages/programmatic" className="block">
        <Card data-testid="cockpit-tile-programmatic-batches">
          <CardContent className="p-4">
            <div className="text-xs uppercase tracking-wide text-muted-foreground flex items-center gap-1">
              <Layers className="size-3" /> Programmatic Batches
            </div>
            <div
              className="mt-2 text-2xl font-semibold tabular-nums"
              data-testid="cockpit-tile-programmatic-batches-count"
            >
              {batches}
            </div>
            <div className="text-xs text-muted-foreground mt-1">last 30 days</div>
          </CardContent>
        </Card>
      </Link>
    </section>
  );
}
